import { useContext } from 'react';
import { ProcessAuthContext } from '~/contexts/processAuth';

export default function useProcessAuth() {
  const context = useContext(ProcessAuthContext);

  return context;
}
